import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { TranslatePipe } from '@ngx-translate/core';
import { MemberStateService } from '../../../features/registration/application/member-state.service';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-layout',
    imports: [RouterOutlet, TranslatePipe],
    template: `
    <div id="app-layout">
      <div class="wrapper">
        <header class="main-header">
          <div class="container">
            <a href="/" class="logo">
              <img src="img/preview-logo.png" alt="" />
            </a>
            <div class="mobile-nav-btn">
              <a href="/" class="nav-member"></a>
              <a href="#" class="nav-menu nav-toggle"></a>
            </div>
            <div class="mobile-nav">
              <ul class="top-nav">
                <li><a style="padding: 10px 23px;" href="/" class="top-btn btn-c-suma100yellow"><small>お申し込み<br>見学予約</small></a></li>
                <li><a [href]="sfTop + '/contact'" class="top-btn btn-c-suma100bluepale">お問い合わせ</a></li>
                <li><a [href]="sfTop + '/legacy/public/signin'" class="top-btn btn-c-suma100blue">マイページ</a></li>
              </ul>
              <div class="clearfix"></div>
              <div class="nav-divider">メインメニュー</div>
              <nav class="pri-nav">
                <ul>
                  <li><a [href]="sfTop + '/introduce'">Smart Fit100とは</a></li>
                  <li><a [href]="sfTop + '/membership'">入会のご案内</a></li>
                  <li><a [href]="sfTop + '/shop'">店舗一覧</a></li>
                  <li><a [href]="sfTop + '/facility'">設備・プログラム</a></li>
                  <li><a [href]="sfTop + '/faq'">よくある質問</a></li>
                </ul>
              </nav>
              <div class="clearfix"></div>
              <div class="nav-divider">会社情報</div>
              <div class="com-info">
                <span class="hidden-xs">会社情報 : </span>
                <a [href]="sfTop + '/about'">会社概要</a><span class="hidden-xs">｜</span>
                <a [href]="sfTop + '/privacy'">個人情報保護方針</a><span class="hidden-xs">｜</span>
                <a [href]="sfTop + '/transaction-law'" class="twoline">特定商取引法に基づく表記</a><span class="hidden-xs">｜</span>
                <a [href]="sfTop + '/term'">利用規約</a><span class="hidden-xs">｜</span>
                <a [href]="sfTop + '/facility-rule'">施設利用ルール</a><span class="hidden-xs">｜</span>
                <a [href]="sfTop + '/contact'">お問い合わせ</a>
              </div>
              <div class="com-add">
                <a href="#" class="flogo"><img src="img/preview-logo.png" alt=""/></a>
                <span>〒103-0014 東京都中央区日本橋蛎殻町2丁目8-12</span>
              </div>
            </div>
            <div class="mobile-nav-close nav-toggle">
              <a href="#"><img src="" alt="" /></a>
            </div>
            <div class="nav-overlay"></div>
          </div>
        </header>

        <div [style.font-family]="state.lang === 'zh-CN' ? 'serif' : 'inherit'" class="content-wrapper">
          <div class="breadcrumbs">
            <div class="container">
              <ul>
                @if (!state.visitors) {
                  <li><a [href]="sfTop">TOP</a></li>
                  @if (!state.btResult) {
                    <li class="active">{{ 'membershipRegistration' | translate }}</li>
                  }
                } @else {
                  <li class="active">&nbsp;</li>
                }
              </ul>
            </div>
          </div>
          @if (!state.btResult) {
            <div class="subpage-title">
              <div class="container">
                @if (!state.visitors) {
                  <h1>{{ 'membershipRegistration' | translate }}</h1>
                } @else {
                  <h1>ご来館アンケート</h1>
                }
              </div>
            </div>
          }
          <router-outlet></router-outlet>
        </div>

        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <a href="#" class="gotop-xs"><i class="glyphicon glyphicon-menu-up"></i><span>  Page Top</span></a>
            </div>
          </div>
        </div>

        <footer>
          <div class="container"></div>
          <div class="list-stores hidden-xs"></div>
          <div class="com-info">
            <span class="hidden-xs">会社情報 : </span>
            <a [href]="sfTop + '/about'">会社概要</a><span class="hidden-xs">｜</span>
            <a [href]="sfTop + '/privacy'">個人情報保護方針</a><span class="hidden-xs">｜</span>
            <a [href]="sfTop + '/transaction-law'">特定商取引法に基づく表記</a><span class="hidden-xs">｜</span>
            <a [href]="sfTop + '/term'">利用規約</a><span class="hidden-xs">｜</span>
            <a [href]="sfTop + '/facility-rule'">施設利用ルール</a><span class="hidden-xs">｜</span>
            <a [href]="sfTop + '/contact'">お問い合わせ</a>
          </div>
          <div class="clearfix"></div>
          <div class="com-add">
            <div class="container">
              <a href="/" class="flogo">
                <div class="smartfit-logo">
                  <img src="img/preview-logo.png" alt="" />
                </div>
              </a>
              <span style="text-align: center">〒103-0014 東京都中央区日本橋蛎殻町2丁目8-12 岸波ビル3F</span>
            </div>
          </div>
          <div class="copyright">© 2015 SmartFitness Inc. All Rights Reserved.</div>
        </footer>
        <a class="go-top">
          <i class="glyphicon glyphicon-menu-up"></i>
          <p>Page Top</p>
        </a>
      </div>
    </div>
  `
})
export class LayoutComponent {
  protected stateService = inject(MemberStateService);
  protected get state() { return this.stateService.get(); }
  protected sfTop = environment.sfTopUrl;
}
